<template>
  <div>
    <div ref="fotoPortadaRef" class="fotoportada-container">
      <div class="overlay">
        <!-- MIS XV -->
        <div class="mis-xv-wrapper-fixed">
          <img
            src="@/assets/corona.png"
            alt="Ornamento"
            class="ornamento-img floating"
          />
          <div ref="misXvTopRef" class="mis-xv-top glowing">MIS XV</div>
        </div>

        <!-- NOMBRE Y FECHA -->
        <div ref="nombreRef" class="centered-text-wrapper">
          <div class="nombre-glow">Johanna</div>
          <div ref="fechaRef" class="fecha-evento">
            <span class="fecha-dia">26</span>
            <span class="fecha-separador">|</span>
            <span class="fecha-mes">Julio</span>
            <span class="fecha-separador">|</span>
            <span class="fecha-anio">2025</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import gsap from 'gsap';

export default {
  name: 'NavbarComponent',
  setup() {
    const fotoPortadaRef = ref(null);
    const nombreRef = ref(null);
    const fechaRef = ref(null);
    const misXvTopRef = ref(null);

    onMounted(() => {
      gsap.from(fotoPortadaRef.value, {
        opacity: 0,
        scale: 1.05,
        duration: 1.2,
        ease: 'power2.out'
      });

      gsap.from(misXvTopRef.value, {
        opacity: 0,
        y: -40,
        duration: 1.2,
        delay: 0.5,
        ease: 'power3.out'
      });

      gsap.from(nombreRef.value.querySelector('.nombre-glow'), {
        opacity: 0,
        scale: 0.4,
        y: -20,
        duration: 1.5,
        delay: 1,
        ease: 'back.out(1.7)'
      });

      gsap.to(fechaRef.value.children, {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.2,
        ease: 'power3.out',
        delay: 2
      });
    });

    return {
      fotoPortadaRef,
      nombreRef,
      fechaRef,
      misXvTopRef
    };
  }
};
</script>

<style scoped>

.fotoportada-container {
  position: relative;
  width: 100%;
  height: 80vh;
  overflow: hidden;
  margin-top: -65px;
  background-image: 
    linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.331)), 
    url('@/assets/portada-1.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  z-index: 1;

  /* Efecto de luz sutil */
  box-shadow: 0 -40px 80px rgba(255, 255, 255, 0.2) inset,
              0 20px 40px rgba(0, 0, 0, 0.3);
}


.overlay {
  position: absolute;
  top: 20px;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 2;
}

.mis-xv-wrapper-fixed {
  position: absolute;
  top: 25px;
  left: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 3;
}

.ornamento-img {
  width: 40px;
  filter: brightness(0) invert(1);
  margin-bottom: 4px;
}

.mis-xv-top {
  font-family: 'file';
  font-size: 20px;
  color: white;
  text-align: center;
  animation: glow 2.5s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    text-shadow: 0 0 5px rgba(255, 255, 255, 0.3);
  }
  to {
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.9);
  }
}

.centered-text-wrapper {
  text-align: center;
  padding: 0 40px;
  margin-top: 220px;
}

.nombre-glow {
  font-family: 'FeelingPassionate';
  font-size: 60px;
  color: transparent;
  background: linear-gradient(90deg, #fff, #ffebd9);
  background-clip: text;
  line-height: 2.5;
  -webkit-background-clip: text;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.6);
  display: inline-block;
}

.fecha-evento {
  font-family: 'Karla', sans-serif;
  font-size: 18px;
  color: white;
  text-transform: uppercase;
  text-shadow: 0 0 6px rgba(255, 255, 255, 0.5);
  letter-spacing: 3px;
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: -10px;
  font-weight: 600;
}

.fecha-evento span {
  opacity: 0;
  transform: translateY(20px);
}
</style>

